import { ChangeEvent, FC } from "react";

import { Box, SxProps } from "@mui/material";

import { CheckboxContainer, Checkmark, Input } from "./components";

type TCheckBox = {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  sx?: SxProps;
};

export const Checkbox: FC<TCheckBox> = ({ onChange, checked, sx }) => {
  return (
    <CheckboxContainer sx={{ width: "24px", height: "24px", ...sx }}>
      {checked && (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ width: "100%", height: "100%", background: "#ffdca8" }}
        >
          <Checkmark />
        </Box>
      )}
      <Input type="checkbox" onChange={onChange} checked={checked} />
    </CheckboxContainer>
  );
};
